import { EntryGroupTemplate } from "../../templates/EntryGroupTemplate";
import { OrderedDataFieldTemplate } from "../../templates/OrderedDataFieldTemplate";
import { OrderedEntry } from "../entries/OrderedEntry";

export class EntryGroup {
	public static readonly $type: string = "EntryGroup";
	public readonly $type: string = EntryGroup.$type;

	public id?: number;
	public name: string = "";
	public template!: EntryGroupTemplate;
	public columns: OrderedDataFieldTemplate[] = [];
	public entries: OrderedEntry[] = [];
}
